import React from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { Control, Controller } from 'react-hook-form';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { BranchListItem } from '../../models/dashboard-models';
import { ManualHandout } from '../../models/warehouse-models';
import { distributorSelectStyles } from '../../styles/selectStyles';
import { DeviceCountBranchRow, ISelectItems } from './types';
import { TableBranches } from './TableBranches';

export type DistributorOption = {
    id: number;
    username: string;
    assignedDistributorName?: string | null;
};

interface DistributorTransferTabProps {
    t: (key: string) => string;
    control: Control<ManualHandout>;
    distributors: { items: DistributorOption[] };
    searchInputRef: React.RefObject<HTMLInputElement>;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    hadleFirstDistrbutor: (distributorId: number) => Promise<void>;
    hadleSecondDistrbutor: (distributorId: number) => Promise<void>;
    exportToDistributor1: () => Promise<void>;
    exportToDistributor2: () => Promise<void>;
    selectAllFirstTable: () => void;
    deselectAllFirstTable: () => void;
    selectAllSecondTable: () => void;
    deselectAllSecondTable: () => void;
    distributorOne?: number;
    distributorTwo?: number;
    isLoadingDistributor1: boolean;
    isLoadingDistributor2: boolean;
    isTransferringToDistributor1: boolean;
    isTransferringToDistributor2: boolean;
    filteredFirstTable: BranchListItem[];
    filteredSecondTable: BranchListItem[];
    selectedItems2: BranchListItem[];
    selectedItems1: BranchListItem[];
    selectedItems11: ISelectItems;
    selectedItems22: ISelectItems;
    setSelectedItems1: React.Dispatch<React.SetStateAction<BranchListItem[]>>;
    setSelectedItems2: React.Dispatch<React.SetStateAction<BranchListItem[]>>;
    setSelectedItems11: React.Dispatch<React.SetStateAction<ISelectItems>>;
    setSelectedItems22: React.Dispatch<React.SetStateAction<ISelectItems>>;
    FetchData: (branch: BranchListItem | DeviceCountBranchRow) => Promise<void>;
}

export const DistributorTransferTab = ({
    t,
    control,
    distributors,
    searchInputRef,
    search,
    setSearch,
    hadleFirstDistrbutor,
    hadleSecondDistrbutor,
    exportToDistributor1,
    exportToDistributor2,
    selectAllFirstTable,
    deselectAllFirstTable,
    selectAllSecondTable,
    deselectAllSecondTable,
    distributorOne,
    distributorTwo,
    isLoadingDistributor1,
    isLoadingDistributor2,
    isTransferringToDistributor1,
    isTransferringToDistributor2,
    filteredFirstTable,
    filteredSecondTable,
    selectedItems1,
    selectedItems2,
    selectedItems11,
    selectedItems22,
    setSelectedItems1,
    setSelectedItems2,
    setSelectedItems11,
    setSelectedItems22,
    FetchData,
}: DistributorTransferTabProps) => {
    const distributorOneOptions = distributors.items.filter((distributor) => distributor.id !== distributorTwo);
    const distributorTwoOptions = distributors.items.filter((distributor) => distributor.id !== distributorOne);

    const distributorOneLabel =
        distributors.items.find((distributor) => distributor.id === distributorOne)?.assignedDistributorName ||
        distributors.items.find((distributor) => distributor.id === distributorOne)?.username;
    const distributorTwoLabel =
        distributors.items.find((distributor) => distributor.id === distributorTwo)?.assignedDistributorName ||
        distributors.items.find((distributor) => distributor.id === distributorTwo)?.username;

    return (
        <div className='w-100 pt-3'>
            <div className='d-flex justify-content-center align-items-center'>
                <Col className='col-12 col-md-8 col-lg-5'>
                    <Form.Label className='mb-0 pb-0'>{t('search')}</Form.Label>
                    <Form.Group
                        id='searchContainer'
                        className=' flex-center search w-100 align-items-start p-2'
                        controlId='searchForm'
                    >
                        <Form.Control
                            ref={searchInputRef}
                            autoFocus={false}
                            type='search'
                            value={search}
                            className='form-control shadow-none '
                            onChange={(e) => setSearch(e.target.value)}
                        ></Form.Control>
                    </Form.Group>
                </Col>
            </div>
            <Form className='w-100'>
                <div className='d-flex flex-row align-items-start w-100'>
                    <div className='d-flex flex-column w-50 justify-content-around select-w-100 px-3'>
                        <Form.Group
                            className=' d-flex flex-column mb-2 w-50 align-items-start ms-3'
                            controlId='forUser'
                        >
                            <Form.Label>{t('distributor1')}</Form.Label>
                            <Controller
                                control={control}
                                name='forUser'
                                rules={{ required: true }}
                                render={() => (
                                    <>
                                        <Select
                                            className='w-100'
                                            onChange={(newValue) => {
                                                void hadleFirstDistrbutor(Number(newValue?.id));
                                            }}
                                            options={distributorOneOptions}
                                            getOptionLabel={(distributor) => distributor.username}
                                            getOptionValue={(distributor) => distributor.username}
                                            styles={distributorSelectStyles}
                                        />
                                    </>
                                )}
                            />
                        </Form.Group>
                        <div className='d-flex flex-wrap gap-2 px-3 mb-3'>
                            <Button
                                variant='primary'
                                disabled={
                                    Object.keys(selectedItems11).length === 0 ||
                                    !distributorTwo ||
                                    isLoadingDistributor1 ||
                                    isTransferringToDistributor2
                                }
                                onClick={() => {
                                    void exportToDistributor2();
                                }}
                            >
                                {isTransferringToDistributor2 ? (
                                    <>
                                        <Spinner animation='border' size='sm' className='me-2' />
                                        Прехвърляне...
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon className='fa-fw me-1' icon={faArrowRight} color={'white'}></FontAwesomeIcon>
                                        {`Прехвърли избраните (${selectedItems1.length} от ${filteredFirstTable.length})`}
                                    </>
                                )}
                            </Button>
                            <Button
                                variant='outline-primary'
                                disabled={filteredFirstTable.length === 0 || isLoadingDistributor1 || isTransferringToDistributor2}
                                onClick={selectAllFirstTable}
                            >
                                Маркирай всички
                            </Button>
                            <Button
                                variant='outline-secondary'
                                disabled={selectedItems1.length === 0 || isLoadingDistributor1 || isTransferringToDistributor2}
                                onClick={deselectAllFirstTable}
                            >
                                Отмаркирай всички
                            </Button>
                        </div>

                        <TableBranches
                            headings={['name', 'companyName', 'price', 'paymentDate']}
                            columns={filteredFirstTable}
                            selectedItems={selectedItems11}
                            setSelectedItems={setSelectedItems11}
                            setSelectedBranchItems={setSelectedItems1}
                            FetchData={FetchData}
                            loading={isLoadingDistributor1}
                        />
                    </div>
                    <div className='d-flex flex-column w-50 px-3 justify-content-around select-w-100'>
                        <Form.Group
                            className=' d-flex flex-column mb-2 w-50 align-items-start ms-3'
                            controlId='forUser'
                        >
                            <Form.Label>{t('distributor2')}</Form.Label>
                            <Controller
                                control={control}
                                name='forUser'
                                rules={{ required: true }}
                                render={() => (
                                    <>
                                        <Select
                                            className='w-100'
                                            onChange={(newValue) => {
                                                void hadleSecondDistrbutor(Number(newValue?.id));
                                            }}
                                            options={distributorTwoOptions}
                                            getOptionLabel={(distributor) => distributor.username}
                                            getOptionValue={(distributor) => distributor.username}
                                            styles={distributorSelectStyles}
                                        />
                                    </>
                                )}
                            />
                        </Form.Group>
                        <div className='d-flex flex-wrap gap-2 px-3 mb-3'>
                            <Button
                                variant='primary'
                                disabled={
                                    selectedItems2.length === 0 ||
                                    !distributorOne ||
                                    isLoadingDistributor2 ||
                                    isTransferringToDistributor1
                                }
                                onClick={() => {
                                    void exportToDistributor1();
                                }}
                            >
                                {isTransferringToDistributor1 ? (
                                    <>
                                        <Spinner animation='border' size='sm' className='me-2' />
                                        Прехвърляне...
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon className='fa-fw me-1' icon={faArrowLeft} color={'white'}></FontAwesomeIcon>
                                        {`Прехвърли избраните (${selectedItems2.length} от ${filteredSecondTable.length})`}
                                    </>
                                )}
                            </Button>
                            <Button
                                variant='outline-primary'
                                disabled={filteredSecondTable.length === 0 || isLoadingDistributor2 || isTransferringToDistributor1}
                                onClick={selectAllSecondTable}
                            >
                                Маркирай всички
                            </Button>
                            <Button
                                variant='outline-secondary'
                                disabled={selectedItems2.length === 0 || isLoadingDistributor2 || isTransferringToDistributor1}
                                onClick={deselectAllSecondTable}
                            >
                                Отмаркирай всички
                            </Button>
                        </div>
                        <TableBranches
                            headings={['name', 'companyName', 'price', 'paymentDate']}
                            columns={filteredSecondTable}
                            selectedItems={selectedItems22}
                            setSelectedItems={setSelectedItems22}
                            setSelectedBranchItems={setSelectedItems2}
                            FetchData={FetchData}
                            loading={isLoadingDistributor2}
                        />
                    </div>
                </div>
            </Form>
        </div>
    );
};
